import React from 'react'
import { Link } from 'react-router-dom'
import { useOrganizationName } from './use-organization-names'

// An organization a page knows only by id, named (owner 2026-10-21: "Lilly ·
// #9060") and linked to its page once content's organization search knows
// it. An id the search doesn't name (removed, or not yet answered) shows alone.
export const OrganizationRef = ({ id }) => {
  const name = useOrganizationName(id)
  return name
    ? <Link to={`/admin/organization/list/edit/${id}`}>{`${name} · #${id}`}</Link>
    : <span>{`#${id}`}</span>
}
